import React from 'react';

const SwitchSection = () => {
  return (
    <section className="switch-section">
      <h2>Perché scegliere Baby Bolle?</h2>
      <p style={{ marginBottom: '40px' }}>Benefici comprovati per lo sviluppo del tuo bambino:</p>
      
      <div className="bubbles-container">
        <div className="bubble" style={{ width: '160px', height: '160px' }}><h4>100%</h4><span>Sicuro</span></div>
        <div className="bubble" style={{ width: '130px', height: '130px' }}><h4>Sonno</h4><span>Migliore</span></div>
        <div className="bubble" style={{ width: '110px', height: '110px' }}><h4>Motorie</h4><span>Abilità</span></div>
        <div className="bubble" style={{ width: '100px', height: '100px' }}><h4>Coliche</h4><span>Sollievo</span></div>
        <div className="bubble" style={{ width: '90px', height: '90px' }}><h4>Legame</h4><span>Fiducia</span></div>
      </div>

      <a href="/" className="btn">Prenota la Prima Sessione</a>
    </section>
  );
};

export default SwitchSection;
